import {IFilterFunction} from "angular";
import {ContractNoteSide, contractNoteSideName} from "../../types/ContractNoteRecord";

export const CNoteSide = "tfCNoteSide";

export function cNoteSide(): IFilterFunction {
    return (side: ContractNoteSide | null) => {
        if (side == null) {
            return null;
        } else {
            return contractNoteSideName(side);
        }
    };
}
